import ES from "./ES.json"
import FR from "./FR.json"
import PT from "./PT.json"

const provinces = { ES, FR, PT }

export default provinces
